"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = ({ typography, spacing, palette }) => ({
    headlineText: {
        fontWeight: typography.fontWeightLight,
        lineHeight: spacing(4),
        letterSpacing: 0.2,
        minWidth: 400,
    },
    header: {
        marginBottom: spacing(2),
    },
    headerActions: {
        display: 'flex',
        alignItems: 'center',
        gap: spacing(2),
    },
    smartSearch: {
        '&&': {
            border: `1px solid ${palette.border.default}`,
            borderRadius: 6,
            paddingLeft: spacing(1),
            paddingRight: spacing(1),
            color: palette.icon.secondary,
        },
        '&&:hover, &&:focus-within': {
            color: palette.icon.secondary,
        },
    },
    headlineIcon: {
        maxHeight: spacing(4),
        maxWidth: spacing(4),
        width: 'auto',
        height: 'auto',
        marginRight: spacing(1),
        marginBottom: 4,
        color: palette.icon.secondary,
    },
    rulesTable: {
        tableLayout: 'fixed',
    },
    thFont: {
        fontWeight: typography.fontWeightMedium,
        color: palette.text.strong,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    tableCell: {
        verticalAlign: 'middle',
        position: 'relative',
    },
    emptyStateCell: {
        paddingTop: spacing(3),
        paddingBottom: spacing(3),
    },
    emptyStateText: {
        color: palette.text.tertiary,
    },
});
exports.default = styles;
